<template>
  <section class="resume-section" id="interests">
    <div class="resume-section-content">
      <h2 class="mb-5">Interests</h2>
      <p>I love learning new tech stacks. I constantly read about both new and old frameworks and languages to get
      a better sense of the technological landscape. I also enjoy reading books that focus on the bigger picture of
      software development like "Clean Code" and "The Unicorn Project".</p>
      <p class="mb-0">Outside of technology, I play piano, drums, and a few other instruments.
      I've started rock climbing (despite a fear of heights). I love road trips and so far have been to 40 out of 50 states.</p>
    </div>
  </section>
</template>

<script>
export default {
name: "Interests"
}
</script>

<style scoped>

</style>